(function() {
  function initFaq(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-sh-faq]').forEach(function(faq) {
      faq.querySelectorAll('.sh-sp-faq__button').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var item = btn.closest('.sh-sp-faq__item');
          if (!item) return;
          if (faq.hasAttribute('data-accordion')) {
            faq.querySelectorAll('.sh-sp-faq__item').forEach(function(other) {
              if (other !== item) other.classList.remove('is-open');
            });
          }
          item.classList.toggle('is-open');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initFaq(document); });
  } else {
    initFaq(document);
  }
})();


document.addEventListener("DOMContentLoaded", function () {

  const forms = document.querySelectorAll(".sh-sp-form");

  forms.forEach(function (form) {

    const messageBox = form.querySelector(".sh-sp-form-message");
    const submitBtn = form.querySelector(".sh-sp-btn");

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      // Inputs
      const firstName = form.querySelector('input[placeholder="First name"]');
      const lastName = form.querySelector('input[placeholder="Last name"]');
      const email = form.querySelector('input[type="email"]');
      const phone = form.querySelector('input[type="tel"]');
      const subject = form.querySelector(".sh-sp-select");
      const message = form.querySelector(".sh-sp-textarea");

      // Clear previous message
      messageBox.innerHTML = "";
      messageBox.className = "sh-sp-form-message";


      // Validation
      if (!firstName.value.trim() || 
          !lastName.value.trim() || 
          !email.value.trim() || 
          !message.value.trim()) {

        messageBox.innerHTML = `
          <strong>Error:</strong> Please fill all required fields.
        `;

        messageBox.classList.add("error");

        return;
      }


      // Email validation
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailPattern.test(email.value)) {

        messageBox.innerHTML = `
          <strong>Error:</strong> Please enter a valid email address.
        `;

        messageBox.classList.add("error");

        return;
      }


      // Disable button
      submitBtn.disabled = true;
      submitBtn.classList.add("loading");
      submitBtn.innerHTML = "Submitting...";


      /*
        AJAX submission can be added here
        Example:
        fetch('/contact')
      */


      setTimeout(function () {

        messageBox.innerHTML = `
          <strong>Success!</strong> 
          Thank you ${firstName.value}. Your message has been submitted successfully.
          We will contact you soon.
        `;

        messageBox.classList.add("success");


        // Reset form
        form.reset();


        // Restore button
        submitBtn.disabled = false;
        submitBtn.classList.remove("loading");
        submitBtn.innerHTML = "{{ section.settings.form_button_label }}";


      }, 1200);


    });

  });

});